<template>
  <div>
    <el-button
      @click="dialogVisibles = true"
      size="small"
      v-if="this.type == 'mirror'"
      >操盘手设置</el-button
    >
    <el-dialog
      :visible.sync="dialogVisibles"
      title="操盘手设置"
      width="800px"
      @close="closeDialog"
      @open="onOpen"
    >
      <el-form :model="baseForm" ref="baseForm" label-width="200px">
        <el-form-item label="交易对" prop="pair">
          <template>
            <span>{{ val.pair }}</span>
          </template>
        </el-form-item>

        <el-form-item label="机器人ID" v-if="type === 'mirror'">
          <span>{{ baseForm.robotUserId }}</span>
        </el-form-item>

        <el-form-item label="错位镜像管理操盘目标价格" prop="target">
          <el-input-number v-model="baseForm.target"></el-input-number>
        </el-form-item>
        <el-form-item label="达成目标价格所需时间(秒)" prop="targetTime">
          <el-input-number v-model="baseForm.targetTime"></el-input-number>
        </el-form-item>
        <el-form-item label="变化频率(秒)" prop="frequency">
          <el-input-number v-model="baseForm.frequency"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibles = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">执行</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CreateContent',
  props: ['val', 'type'],
  data() {
    return {
      dialogVisibles: false,
      baseForm: {
        robotUserId: this.val.robotUserId,
        pair: this.val.pair,
        target: this.val.target,
        targetTime: this.val.targetTime,
        frequency: this.val.frequency
      }
    };
  },
  methods: {
    ...mapActions('robotpingSetting', ['setBargain', 'getList']),
    onOpen() {
      this.baseForm = Object.assign({}, this.val);
    },
    closeDialog() {
      this.$refs['baseForm'].resetFields();
    },
    handleSave() {
      this.setBargain({ type: this.type, content: this.baseForm }).then(() => {
        this.$message.success('成功！');
        this.getList({ style: this.type, type: 1 });
        this.dialogVisibles = false;
      });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
